import { render, staticRenderFns } from "./CombinedPredict.vue?vue&type=template&id=575b54d1"
import script from "./CombinedPredict.vue?vue&type=script&setup=true&lang=js"
export * from "./CombinedPredict.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports